// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sq7MU","colBig":"styles_colBig__30yQE","colSmall":"styles_colSmall__H-Yaq"};